
export default {
  name: 'BaseActionButton',
  props: {
    // 颜色语义:primary=流程推进蓝 / success=完成绿(送达等"收尾即成功"动作) / inspect=验货黄 / attention=注意橙 / danger=危险红 / neutral=灰
    semantic: {
      type: String,
      default: 'primary',
      validator: v => ['primary', 'success', 'inspect', 'attention', 'danger', 'neutral'].includes(v)
    },
    // 呈现变体:filled=实底(每屏唯一主操作) / outline=线框(选路/注意次级) / flat=纯文字(辅助) / soft=浅底(chips) / neutral=灰实底(取消)
    variant: {
      type: String,
      default: 'filled',
      validator: v => ['filled', 'outline', 'flat', 'soft', 'neutral'].includes(v)
    },
    size: {
      type: String,
      default: 'md',
      validator: v => ['sm', 'md', 'lg'].includes(v)
    },
    label: { type: String, default: '' },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    block: { type: Boolean, default: false },
    nativeType: { type: String, default: 'button' }
  },
  computed: {
    // variant=neutral 是"灰实底取消键"的快捷写法,等价 semantic=neutral + filled
    variantClass () {
      return 'base-action-btn--v-' + (this.variant === 'neutral' ? 'neutral' : this.variant)
    }
  },
  methods: {
    // loading 时不派发 click(防重复提交);正常点击原样透传
    onClick (e) {
      if (this.loading || this.disabled) return
      this.$emit('click', e)
    }
  }
}
